import TextBlock 		from './default'
import TextBlockIntro 	from './intro'
import TextBlockQuote 	from './quote'

export {
	TextBlock,
	TextBlockIntro,
	TextBlockQuote
}